import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"margin-bottom":"5px"} }
const _hoisted_2 = /*#__PURE__*/_createVNode("label", { style: {"color":"#F56C6C","margin-right":"4px"} }, "*", -1)
const _hoisted_3 = {
  ref: "downloadEle",
  href: "/download/template/template-kit.xlsx",
  download: "",
  class: "display-none"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_dialog_shell = _resolveComponent("dialog-shell")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_dialog_shell, {
      title: _ctx.$wordList.ProperAllTextImportKitEndUser,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close'))),
      onSubmit: _ctx.submit
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "label-position": _ctx.$formLabelPosition,
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "form"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.$wordList.TabelResetPwInHtmlAccount,
              prop: "Account"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.Account,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.Account = $event)),
                  "auto-complete": "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode("div", _hoisted_1, [
              _hoisted_2,
              _createVNode("label", null, _toDisplayString(_ctx.$wordList.TabelPersonDeviceInHtmlDeviceTypeIndoor), 1)
            ]),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_cus_button, {
                  class: "margin-right10px",
                  onClick: _ctx.importClick
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$wordList.RDeiviceImport), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_cus_button, { onClick: _ctx.download }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextKitImportTemplate), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode("input", {
                  type: "file",
                  ref: "fileEle",
                  accept: ".xlsx",
                  onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.choose && _ctx.choose(...args))),
                  class: "display-none"
                }, null, 544),
                _createVNode("a", _hoisted_3, null, 512),
                _hoisted_4,
                _createTextVNode(" " + _toDisplayString(_ctx.fileName), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["label-position", "model", "rules"])
      ]),
      _: 1
    }, 8, ["title", "onSubmit"])
  ]))
}